$(document).ready(function () {
  var modal_background = document.getElementById("modal_pdf");
  var modal = document.getElementById("modal_excerpt");

  $('#excerpt').click(function() {
    $(modal_background)
        .css("display", "block");
    $(modal)
        .css("display", "block");
    $("html")
        .css("overflow", "hidden");
  });

  $('.close_modal_excerpt').click(function() {
      $(modal_background)
          .css("display", "none");
      $(modal)
          .css("display", "none");
      $("html")
          .css("overflow", "auto");
    });

  
});